import { Typography } from "antd";

const { Title } = Typography;

/** Parcelamentos simulados no resumo, além do à vista. */
const PARCELAS = Array.from({ length: 12 }, (_, indice) => indice + 2); // 2x .. 13x

function formatCurrency(valor: number) {
  return (valor || 0).toLocaleString("pt-br", { style: "currency", currency: "BRL" });
}

/** Valor de cada parcela, arredondado como o step de Pagamento arredonda. */
export function valorDaParcela(valorTotal: number, parcelas: number): number {
  if (!valorTotal || parcelas <= 0) return 0;
  return Number((valorTotal / parcelas).toFixed(2));
}

type Props = {
  /** Disciplinas + produtos, já com os descontos aplicados. */
  valorTotal: number;
};

/**
 * Simulação de pagamento da matrícula: valor total, à vista e de 2x a 13x.
 * É só projeção — não interfere nas parcelas efetivamente lançadas no step de
 * Pagamento. Acompanha o total, então muda junto com disciplinas e produtos.
 */
export function ResumoPagamento({ valorTotal }: Props) {
  return (
    <section
      aria-label="Resumo de Pagamento"
      className="mt-6 rounded-md border border-gray-700 bg-gray-900 p-4"
    >
      <Title level={5} style={{ marginTop: 0, marginBottom: 12 }}>
        Resumo de Pagamento
      </Title>

      <div className="mb-3 border-b border-gray-700 pb-3">
        <div className="text-xs text-zinc-400">Valor Total (Disciplinas + Produtos)</div>
        <div className="text-lg font-semibold text-zinc-50" aria-label="Valor Total">
          {formatCurrency(valorTotal)}
        </div>
      </div>

      <dl className="m-0 flex flex-col gap-1 text-sm">
        <div className="flex items-baseline justify-between gap-2">
          <dt className="text-zinc-400">À vista</dt>
          <dd className="m-0 text-zinc-50">{formatCurrency(valorTotal)}</dd>
        </div>

        {PARCELAS.map((parcelas) => (
          <div key={parcelas} className="flex items-baseline justify-between gap-2">
            <dt className="text-zinc-400">{`${parcelas}x de`}</dt>
            <dd className="m-0 text-zinc-50">
              {formatCurrency(valorDaParcela(valorTotal, parcelas))}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

export default ResumoPagamento;
